var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83434 11.7657C5.52192 11.4533 5.52192 10.9467 5.83434 10.6343L8.46865 8L5.83434 5.36568C5.52192 5.05327 5.52192 4.54673 5.83434 4.23431C6.14676 3.9219 6.65329 3.9219 6.96571 4.23431L10.1657 7.43431C10.4781 7.74673 10.4781 8.25327 10.1657 8.56569L6.96571 11.7657C6.65329 12.0781 6.14676 12.0781 5.83434 11.7657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrowRight);
export default __webpack_public_path__ + "static/media/sidebar-arrow-right.8334427652a0139ca883f85468577853.svg";
export { ForwardRef as ReactComponent };